import { create } from 'zustand';
const useMetricsOutput = create(() => ({
    currentValues: {},
    newDataPoints: {},
}));
const reactiveOutput = {
    useMetrics: () => {
        return useMetricsOutput((s) => s.currentValues);
    },
    useNewDataPoints: () => {
        return useMetricsOutput((s) => s.newDataPoints);
    },
};
export class MetricsServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setMetric(metric, value) {
        useMetricsOutput.setState((state) => ({
            ...state,
            currentValues: {
                ...state.currentValues,
                [metric]: value,
            },
        }));
    }
    setMetrics(metrics) {
        useMetricsOutput.setState((state) => ({
            ...state,
            currentValues: {
                ...state.currentValues,
                ...metrics,
            },
        }));
    }
    addDataPoints(dataPoints) {
        useMetricsOutput.setState((state) => {
            // Update current values with the latest from each metric
            const currentValues = { ...state.currentValues };
            Object.entries(dataPoints).forEach(([metric, points]) => {
                if (points.length > 0) {
                    currentValues[metric] = points[points.length - 1].value;
                }
            });
            return {
                currentValues,
                newDataPoints: dataPoints,
            };
        });
    }
    clearNewDataPoints() {
        useMetricsOutput.setState((state) => ({
            ...state,
            newDataPoints: {},
        }));
    }
}
